export default __webpack_public_path__ + "static/media/HaloHIW.ce36bb97.mp4";